import Style from './index.module.less'
import BlockTitle from '@/components/BockTitle'
import LatestBlockCard from '@/components/LatestBlockTwo'
import LatestTransactions from '@/components/LatestTransactions'
import SeeTransBtn from '@/components/seeTransBtn'
import classNames from 'classnames'
import { type Block, type Transition } from '@/hoxStore/interface'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getUniqueHashObjects } from './utils'
import useMeNavigate from '@/hooks/useMeNavigate'
import MeEmpty from '@/components/MeEmpty'
import { useGlobalStore } from '@/hoxStore/globalStore'

function generateUniqueString() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

const LatestBlock = ({
  blocks = [],
  transitions = [],
}: {
  showRight?: boolean
  blocks: Block[]
  transitions: Transition[]
}) => {
  const { curReponsive } = useGlobalStore()
  const navigate = useMeNavigate()
  const { t } = useTranslation()
  //  最新区块
  const [testItem, setTestItem] = useState<Block[]>([])
  const latestBlockDataList = useRef<Block[]>([])
  const addTermsLength = useRef(1)
  const testItemTimeId = useRef<NodeJS.Timeout>()

  // 最新交易
  const [latestTransactionsList, setLatestTransactionsList] = useState<Transition[]>([])
  const latestTransactionsDataList = useRef<Transition[]>([])
  const addLatestTransactionsDataListLength = useRef(1)
  const latestTransactionsTimeId = useRef<NodeJS.Timeout>()

  /** 更新latestBlockDataList 最新区块 */
  useEffect(() => {
    if (blocks?.length && latestBlockDataList.current.length === 0) {
      // 初始化数据
      //添加数据的索引，数据的key
      const newBlocks = JSON.parse(JSON.stringify(blocks)).map((item: Block, index: number) => {
        return {
          ...item,
          index,
          indexKey: generateUniqueString(),
        }
      })
      setTestItem(newBlocks)
      latestBlockDataList.current = newBlocks
    }
    if (
      blocks?.length &&
      latestBlockDataList.current.length &&
      blocks[0].height !== latestBlockDataList.current[0].height
    ) {
      // 进到这里说明数据更新了
      // 赋值已经存在的key
      // 赋值key
      const newBlocks = JSON.parse(JSON.stringify(blocks))
      // 赋值已经存在的indexKey和key 给新数据
      const newBlocksMap = newBlocks.map((item: Block) => {
        const newItem = item
        const readItem = latestBlockDataList.current.find((i) => i.height === item.height)
        if (readItem) {
          newItem.indexKey = readItem.indexKey
          newItem.index = readItem.index
        }
        return newItem
      })

      // 找到新增的数据
      const newBlocksItem = newBlocksMap.filter((j: Block) => {
        const item = latestBlockDataList.current.find((i) => i.height === j.height)
        return !item
      })
      // 新增的数据添加新的index 和indexKey
      newBlocksItem.forEach((item: Block, index: number) => {
        item.indexKey = generateUniqueString()
        item.index = index - newBlocksItem.length
      })
      // 新增数据的长度
      addTermsLength.current = newBlocksItem.length
      // 赋值最新的数据
      latestBlockDataList.current = newBlocksMap
      // 赋值最新的数据
      setTestItem(newBlocks)
      testItemTimeId.current = setTimeout(() => {
        // 更新后16秒执行动画
        latestBlockDataList.current.forEach((i) => {
          i.index = i.index + addTermsLength.current
        })
        setTestItem(latestBlockDataList.current)
        clearTimeout(testItemTimeId.current)
      }, 16)
    }
  }, [blocks])

  /** 更新latestBlockDataList 最新交易 */
  useEffect(() => {
    if (transitions?.length && latestTransactionsDataList.current.length === 0) {
      // 初始化数据
      //添加数据的索引，数据的key
      const newTransitions = JSON.parse(JSON.stringify(transitions.slice(0, 10))).map(
        (item: Transition, index: number) => {
          return {
            ...item,
            index,
            indexKey: item.hash,
          }
        },
      )
      setLatestTransactionsList(newTransitions)
      latestTransactionsDataList.current = newTransitions
    }
    if (
      transitions?.length &&
      latestTransactionsDataList.current.length &&
      transitions[0].hash !== latestTransactionsDataList.current[0].hash
    ) {
      // 进到这里说明数据更新了
      // 赋值已经存在的key
      // 赋值key
      const originNewTransitions = JSON.parse(JSON.stringify(transitions.slice(0, 5)))
      const newTransitions = originNewTransitions.filter((j: Transition) => {
        const item = latestTransactionsDataList.current.find((i) => i.hash === j.hash)
        return !item
      })
      // 赋值已经存在的indexKey和key 给新数据
      const newTransitionsMap = newTransitions.map((item: Transition) => {
        const newItem = item
        const readItem = latestTransactionsDataList.current.find((i) => i.hash === item.hash)
        if (readItem) {
          newItem.indexKey = readItem.indexKey
          newItem.index = readItem.index
        }
        return newItem
      })

      // 找到新增的数据
      const newTransitionsItem = newTransitionsMap.filter((j: Transition) => {
        const item = latestTransactionsDataList.current.find((i) => i.hash === j.hash)
        return !item
      })
      // 新增原长度
      // 新增的数据添加新的index 和indexKey
      newTransitionsItem.forEach((item: Transition, index: number) => {
        item.indexKey = item.hash
        item.index = index - newTransitionsItem.length
      })

      // 新增数据的长度

      addLatestTransactionsDataListLength.current = newTransitionsItem.length
      const oldLatestTransactionsList = latestTransactionsList.slice(0, 10)
      setLatestTransactionsList([...newTransitions, ...oldLatestTransactionsList])
      const oldLatestTransactionsDataList = latestTransactionsDataList.current.slice(0, 10)
      latestTransactionsDataList.current = [...newTransitionsMap, ...oldLatestTransactionsDataList]
      latestTransactionsTimeId.current = setTimeout(() => {
        // 更新后16秒执行动画
        latestTransactionsDataList.current.forEach((i) => {
          i.index = i.index + addLatestTransactionsDataListLength.current
        })
        setLatestTransactionsList(latestTransactionsDataList.current)
        clearTimeout(latestTransactionsTimeId.current)
      }, 100)
    }
  }, [transitions])

  return (
    <div
      className={classNames({
        [Style.wrap]: true,
      })}
    >
      <div>
        {/* 最新区块 */}
        <BlockTitle title={t('explorer_9')}></BlockTitle>
        <div
          className={classNames({
            block_list: true,
            block_list_empty: !testItem.length && curReponsive?.size === 'mobile',
          })}
        >
          {testItem.length ? (
            testItem.slice(0, 6).map((item, index) => {
              return (
                <div
                  key={item.indexKey}
                  className={Style.latestBlockCardItem}
                  style={{
                    top: `${item.index * 110}px`,
                  }}
                >
                  <LatestBlockCard index={index} key={index} cardData={item}></LatestBlockCard>
                </div>
              )
            })
          ) : (
            <div className={Style.noData}>
              <MeEmpty text={t('explorer_233')}></MeEmpty>
            </div>
          )}
        </div>
        <div className="see_btn">
          {testItem.length ? (
            <SeeTransBtn
              onClick={() => {
                navigate('/blockchain')
              }}
              btnName={t('explorer_12')}
            />
          ) : null}
        </div>
      </div>
      <div>
        {/* 最新交易 */}
        <BlockTitle title={t('explorer_19')}></BlockTitle>
        <div
          className={classNames({
            block_list: true,
            block_list_empty: !latestTransactionsList.length && curReponsive?.size === 'mobile',
          })}
        >
          {latestTransactionsList.length ? (
            latestTransactionsList.slice(0, 10).map((item, index) => {
              return (
                <div
                  key={item.indexKey}
                  className={Style.latestTransactionsCardItem}
                  style={{
                    top: `${item.index * 110}px`,
                  }}
                >
                  <LatestTransactions key={index} cardData={item}></LatestTransactions>
                </div>
              )
            })
          ) : (
            <div className={Style.noData}>
              <MeEmpty text={t('explorer_233')}></MeEmpty>
            </div>
          )}
        </div>
        <div className="see_btn">
          {latestTransactionsList.length ? (
            <SeeTransBtn
              onClick={() => {
                navigate('/transaction')
              }}
              btnName={t('explorer_125')}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default LatestBlock
